import { createSession, getSession } from './session'
import { getJsonCookie, setJsonCookie } from './cookies'
import type { Session } from '@/types/auth'
import { AuthService } from '@/services/auth'

export async function initializeAuth() {
  const session = getSession()
  const authCookie = getJsonCookie('authentication')

  if (!session && authCookie) {
    try {
      const { data: refreshedData } = await AuthService.refreshToken()

      const newPayload = {
        user: refreshedData.user,
        accessToken: refreshedData.token.accessToken,
        accessExpiresIn: refreshedData.token.accessExpiresIn,
        accessExpiresAt: refreshedData.token.accessExpiresAt,
      }

      createSession(newPayload as Session)
      setJsonCookie('authentication', newPayload, { expires: 30 })

      // Unlike the user-fe, we don't need to force a reload here
      // as TanStack Router's context will be updated.
    } catch (error) {
      console.error('Failed to refresh token:', error)
      setJsonCookie('authentication', null, { expires: -1 })
    }
  }
}
